module.exports = __webpack_public_path__ + "static/img/number.0e03a97e.png";